import { render, staticRenderFns } from "./LastEmailContact.vue?vue&type=template&id=16f0aada&"
import script from "./LastEmailContact.vue?vue&type=script&lang=js&"
export * from "./LastEmailContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports